import { useState } from "react"

const ESTADO_CONFIG = {
  distribucion: { label: "en distribución", icon: "fa-truck",        className: "status-distribucion" },
  pendiente:    { label: "pendiente",        icon: "fa-spinner",      className: "status-pendiente"    },
  entregado:    { label: "entregado",        icon: "fa-check-double", className: "status-entregado"    },
  cancelado:    { label: "cancelado",        icon: "fa-ban",          className: "status-cancelado"    },
}

const API = process.env.REACT_APP_API_URL

function OrdenCompraEnvioItem({ envio, canSeeSensible, nroOrdenCompra }) {
  const [modal, setModal] = useState(false)

  const estadoConfig = ESTADO_CONFIG[envio.estado?.toLowerCase()] ?? {
    label: "desconocido", icon: "fa-circle-question", className: "status-unknown",
  }

  const observaciones = envio.observaciones && envio.observaciones !== "Sin observaciones"
    ? envio.observaciones
    : null

  const tieneComprobantes = envio.nroFactura || envio.nroNotaCredito || envio.nroRemito

  return (
    <>
      <div className="ordenCompraEnvioItem row">
        <div>{envio.nroEntrega}</div>
        <div className={`estadoEnvio row ${estadoConfig.className}`}>
          <i className={`fa-solid ${estadoConfig.icon}`} />
          <span>{estadoConfig.label}</span>
        </div>
        <div>{envio.fEntrega ? new Date(envio.fEntrega).toLocaleDateString("es-AR", { timeZone: "UTC" }) : "-"}</div>
        <div>{observaciones ?? "-"}</div>
        <div>
          {envio.adjuntoUrl ? (
            <a href={`${API}${envio.adjuntoUrl}`} download target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-download" title="Descargar adjunto" />
            </a>
          ) : (
            <span>-</span>
          )}
        </div>
        {canSeeSensible && (
          <div>
            <button
              className={`entregaInfoBtn${tieneComprobantes ? " entregaInfoBtn--con-datos" : ""}`}
              onClick={() => setModal(true)}
              title="Ver comprobantes"
            >
              <i className="fa-solid fa-circle-info" />
            </button>
          </div>
        )}
      </div>

      {modal && (
        <div className="entregaModalOverlay" onClick={() => setModal(false)}>
          <div className="entregaModal column" onClick={e => e.stopPropagation()}>
            <div className="entregaModalHeader row spacebetween">
              <span>OC {nroOrdenCompra} — Entrega #{envio.nroEntrega}</span>
              <button className="entregaModalClose" onClick={() => setModal(false)}>
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
            <div className="entregaModalBody column">
              <div className="entregaModalFila row">
                <span className="entregaModalLabel">N° Factura</span>
                <span className="entregaModalValor">{envio.nroFactura || <em>sin datos</em>}</span>
              </div>
              <div className="entregaModalFila row">
                <span className="entregaModalLabel">N° Nota de Crédito</span>
                <span className="entregaModalValor">{envio.nroNotaCredito || <em>sin datos</em>}</span>
              </div>
              <div className="entregaModalFila row">
                <span className="entregaModalLabel">N° Remito</span>
                <span className="entregaModalValor">{envio.nroRemito || <em>sin datos</em>}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default OrdenCompraEnvioItem
